import { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";

/* room3 주방 */

function Room3(){

  const [showFridgePopover, setShowFridgePopover] = useState(false);
  const [fridgePopoverText, setFridgePopoverText] = useState('');
  const fridgeRef = useRef(null);

  const [clickCount, setClickCount] = useState(0);
  const [showPopover, setShowPopover] = useState(false);
  const [popoverText, setPopoverText] = useState('');
  const targetRef = useRef(null);

  const handleShelfClick = () => {
    let nextClick = clickCount + 1;
    setClickCount(nextClick);

    if (nextClick === 1) {
      setPopoverText("... 낡아서인지 살짝 건드렸을 뿐인데 망가졌다");
    } else {
      setPopoverText("... 안 들키겠지");
    }

    setShowPopover(true);

    // 자동으로 popover 숨기기 (2초 뒤)
    setTimeout(() => setShowPopover(false), 2000);
  };

  const handleFridgeClick = () => {
  setFridgePopoverText("대부분의 음식이 상한 것 같다");
  setShowFridgePopover(true);

  setTimeout(() => setShowFridgePopover(false), 2000);
};


  const getTransformStyle = () => {
    if (clickCount === 1) {
      return "rotate(30deg)";
    } else if (clickCount === 2) {
      return "rotate(0deg)";
    } else {
      return "none"; // 이후로는 회전 없음
    }
  };

  const getTransitionStyle = () => {
    if (clickCount <= 2) {
      return "transform 0.5s ease";
    } else {
      return "none"; // 이후로는 애니메이션 없음
    }
  };

    return(
        <div 
        className="d-flex justify-content-center align-content-center flex-wrap" 
        style={{height: 'calc(100vh - 200px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'top',
        gap: '10vw',
        marginTop: '-10vh',
        padding: '0 2vw',
         }}>
        <button
        ref={fridgeRef}
        type="button"
        className="btn btn-secondary"
        onClick={handleFridgeClick}
          style={{
            width: '20vw',
            height: '37vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >냉장고</button>

        <div style={{ position: 'relative', width: '10vw', height: '7vh' }}>

        {/* 그림자 역할 하는 고정된 버튼 */}
        <button
          type="button"
          className="btn btn-secondary"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '10vw',
            height: '7vh',
            backgroundColor: '#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            opacity: 0.7, // 투명도 조절
            pointerEvents: 'none', // 클릭 불가
            border: 'none',
            cursor: 'default',
            fontSize: '70%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            userSelect: 'none',
          }} />

          <button
          ref={targetRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleShelfClick}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '10vw',
            height: '7vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: "70%",
          transform: getTransformStyle(),
          transition: getTransitionStyle(),
          transformOrigin: 'left bottom', // 왼쪽 아래 기준 회전
        }}          
        >선반</button>
        </div>

        {/* Popover */}
      <Overlay target={targetRef.current} show={showPopover} placement="top">
        {(props) => (
          <Popover {...props}>
            <Popover.Body>{popoverText}</Popover.Body>
          </Popover>
        )}
      </Overlay>

      <Overlay target={fridgeRef.current} show={showFridgePopover} placement="top">
        {(props) => (
          <Popover {...props}>
            <Popover.Body>{fridgePopoverText}</Popover.Body>
          </Popover>
        )}
      </Overlay>


          </div>
       );
}

export default Room3;

